const menufuturo = process.env.REACT_APP_FUTURO || '';

export const MenuFiscal =  [
  {
    icon: 'dashboard_customize',
    path: '/dashboardlcdpr',
    label: 'Pagina Inicial',
  },
  {
    icon: 'event_note',
    path: '/nfe',
    label: 'NFE',
  },
  {
    icon: 'card_giftcard',
    path: '/produtosnfe',
    label: 'Produtos NF-e',
  },
  {
    icon: 'auto_stories',
    path: '/lcdpr',
    label: 'LCDPR',
  },
  {
    icon: 'auto_stories',
    path: '/geraarquivo',
    label: 'Gera LCDPR',
  },
  (menufuturo === 'TRUE' ? { icon: 'auto_stories', path: '/lcdpcitros',  label: 'LCDPR CITROS', } : { icon: '', path: 'dashboardlcdpr',  label: '', }),
];  

export const MenuFiscalrelatorio =  [
  {
    icon: 'print',
    path: '/relatorionfe',
    label: 'NFE',
  },
  {
    icon: 'print',
    path: '/relatorioreceitadespesa',
    label: 'Receita Despesa',
  },
  {
    icon: 'print',
    path: '/relatoriolcdpr',
    label: 'LCDPR',
  },
  {
    icon: 'print',
    path: '/relatorioporparceiro',
    label: 'Parceiro',
  },
  {
    icon: 'print',
    path: '/relatorioconta',
    label: 'Conta',
  },
  {
    icon: 'print',
    path: '/relatoriosaldoconta',
    label: 'Saldo Conta',
  },
  {
    icon: 'print',
    path: '/relatoriosaldofazendas',
    label: 'Saldo Fazendas',
  },
  {
    icon: 'print',
    path: '/relatoriofazendas',
    label: 'Fazendas',
  },
  {
    icon: 'print',
    path: '/rconferencianotalcdpr',
    label: 'Conferência Nota LCDPR',
  },
  (menufuturo === 'TRUE' ? { icon: 'print', path: '/relatorioreceitadespesacitros',  label: 'Receita Despesa CITROS', } : { icon: '', path: 'dashboardlcdpr',  label: '', }),
  (menufuturo === 'TRUE' ? { icon: 'print', path: '/relatoriolcdprcitros',  label: 'LCDPR CITROS', } : { icon: '', path: 'dashboardlcdpr',  label: '', }),
];